<template>
    <div>
      <b-alert variant="success" v-show="flash" dismissible v-model="flash">
        Customer Updated
      </b-alert>
      <b-alert variant="danger" v-show="flash" dismissible v-model="danger">
        Error in Processing Update:
        {{ message }}
      </b-alert>
      <b-row v-if="customer">
        <b-col>
          <b-form class="text-left" @submit.stop.prevent="handleSubmit">
            <b-form-group
              label="Customer Name:"
              label-for="name"
            >
            <b-form-input type="text"
                        required
                        id="name"
                        placeholder="Customer Name"
                        v-model="customer.name">
            </b-form-input>
            </b-form-group>
            <b-form-group
              label="Customer Email:"
              label-for="email"
            >
            <b-form-input type="email"
                        required
                        id="email"
                        placeholder="Customer email"
                        v-model="customer.email">
            </b-form-input>
            </b-form-group>
            <b-form-group
              label="Customer Phone:"
              label-for="phone"
            >
            <b-form-input type="text"
                        id="phone"
                        placeholder="Customer Phone"
                        v-model="customer.phone">
            </b-form-input>
            </b-form-group>
            <b-button variant="primary" type="submit">Update Customer</b-button>
          </b-form>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Customer',
  data () {
    return {
      flash: null,
      danger: null,
      message: ''
    }
  },
  props: {
    id: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['customers']),
    customer () {
      return this.customers.find(customer => customer.id === parseInt(this.id))
    }
  },
  methods: {
    submitSuccessful () {
      this.alert = false
      this.flash = true
    },
    submitFailed (e) {
      this.flash = false
      this.alert = true
      this.message = e.response
      console.log(e.response)
    },
    handleSubmit () {
      var vm = this
      this.$http.put(`/customers/${this.customer.id}`, { customer: this.customer })
        .then(function (response) {
          vm.submitSuccessful()
        })
        .catch(function (e) {
          vm.submitFailed(e)
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/customer/Show.vue